<template>
    <dashboard>
        <row>
            <panel size="col-5" class="filters">
                <h3 slot="title">Filters</h3>
                <div class="filter-item">
                    <h4>Mode</h4>
                    <app-segment-control
                        :value="filters.mode"
                        :options="[
                            { value: 'all', title: 'All' },
                            { value: 'issues', title: 'Issues' }
                        ]"
                        @input="modeChanged"/>
                </div>
            </panel>
            <panel size="col-19">
                <h2 slot="title">Setup Report</h2>
                <template slot="buttons">
                    <app-button
                        size="small"
                        icon="icon-download"
                        class="no-text"
                        @click="handleDownload">
                        <span class="visuallyhidden">Download Report</span>
                    </app-button>
                </template>

                <el-table
                    :data="report"
                    :default-sort="{ prop: sort_by }"
                    style="width: 100%"
                    empty-text="None"
                    @current-change="navigateToStudentDetail"
                    @sort-change="sortChange">
                    <el-table-column prop="first_name" label="First Name" sortable="custom"/>
                    <el-table-column prop="last_name" label="Last Name" sortable="custom"/>
                    <el-table-column prop="semester_apa" 
                                     label="APA" 
                                     width="95px" 
                                     sortable>
                        <template slot-scope="scope">{{ apaFormat(scope.row.semester_apa) }}</template>
                    </el-table-column>
                    <el-table-column prop="token" label="Token"/>
                    <el-table-column prop="device.app_version" label="App Version"/>
                    <el-table-column prop="last_seen" label="Last Seen"/>
                </el-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apaFormat } from '@/utilities'
import table from '@/mixins/table'
import download from '@/mixins/download'

export default {
    name: 'page-reports-setup',
    mixins: [download, table],
    props: {
        mode: {
            type: String,
            default: 'issues'
        },
        per_page: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            filters: {
                mode: 'issues'
            },
            tableParamKeys: ['mode']
        }
    },
    computed: {
        ...mapState({
            report: ({ reportList }) => reportList.items,
            total: ({ reportList }) => reportList.total,
            authToken: ({ me }) => me.token
        })
    },
    mounted() {
        this.getSetupReport(this.getParameters())
    },
    methods: {
        ...mapActions(['getSetupReport']),
        handleDownload() {
            let parameters = this.getParameters()
            this.postParameters('/api/v2/download/report/setup',
                parameters,
                this.authToken)
        },
        paramsChanged(params) {
            this.getSetupReport(params)
        },
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        modeChanged(mode) {
            var parameters = this.getParameters()
            parameters.mode = mode
            this.setParameters(parameters)
        },
        apaFormat
    }
}
</script>

<style lang="stylus"></style>
